import React from "react";

const ChequeSpinner = () => {
  return (
    <div className="relative w-32 h-32 mx-auto my-8">
      {/* Cheque SVG */}
      <svg viewBox="0 0 256 256" className="w-full h-full">
        <path
          fill="none"
          stroke="rgb(39 39 42)"
          strokeWidth="2"
          strokeDasharray="1000"
          strokeDashoffset="1000"
          className="animate-draw"
          d="M12.8,75.5C9.9,77,10,74.3,10,128c0,53.9-0.1,51,2.9,52.6c1.2,0.6,11.2,0.7,85.4,0.7c92.4,0,86,0.2,87.6-2.9c0.6-1.1,0.7-3.6,0.7-13.4v-12.1l1.5-0.9c3-1.8,12.7-9.3,18.9-14.8c3.5-3.1,11.8-11,18.4-17.6c16.1-16.1,20.1-21.2,20.6-26.7c0.6-7-4.4-11.2-11.6-9.7c-4.9,1-13.4,7.9-27.5,22.3c-4.8,4.9-11.3,11.9-14.4,15.4l-5.7,6.5l-0.2-24.6c-0.2-18.8-0.4-24.9-0.9-25.7c-1.5-2.7,3.9-2.5-87.5-2.5C24.7,74.7,13.9,74.8,12.8,75.5z M182.4,78.8c0.8,0.7,0.9,1.7,0.9,11.7v10.9h-85H13.3V90.5c0-9.3,0.1-11,0.8-11.7c0.7-0.7,8.9-0.8,84-0.8C175.1,78,181.6,78.1,182.4,78.8z M240.7,87.3c2.4,1.7,2.5,5.9,0.3,9.7c-1.4,2.4-7.3,9.5-10.3,12.3l-2.1,2l-5.6-5.6l-5.6-5.6l3-2.9c3.9-3.8,9.1-7.9,11.8-9.4C234.8,86.4,239,86.1,240.7,87.3z M220.5,108.4l5.6,5.6l-8.2,8.1c-16.8,16.6-31.1,27.9-38.3,30.6c-1.5,0.5-3.4,1.5-4.2,2.1c-1.5,1.1-2.7,1.5-2.7,0.9c0-0.1,0.7-1.2,1.4-2.4c0.8-1.1,1.8-3,2.2-4.1c1.5-4.3,7.5-12.9,15.4-22.1c4.9-5.8,22.4-24.5,22.8-24.5C214.8,102.8,217.4,105.3,220.5,108.4z M183.1,118.4l0.1,13.4l-3.3,4.7c-1.9,2.5-4.5,6.9-5.9,9.6c-1.4,2.8-3,5.8-3.6,6.7c-1.2,2-1.3,4.3-0.2,5.6c1.3,1.6,2.9,1.7,5.3,0.4c2.6-1.4,7.1-3.6,7.4-3.6c0.1,0,0.2,4.8,0.2,10.6c0,9.1-0.1,10.7-0.8,11.4c-0.7,0.8-4,0.9-84.2,0.9c-75.2,0-83.5-0.1-84.1-0.8c-0.7-0.7-0.8-4.6-0.8-36.3c0-19.6,0.1-35.7,0.3-35.9c0.1-0.2,38.4-0.3,84.8-0.2l84.5,0.1L183.1,118.4z"
        />
      </svg>

      {/* Animated pen */}
      {/* <svg className="absolute w-6 h-6 animate-write" viewBox="0 0 24 24">
        <path
          fill="#ef4444"
          d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
        />
      </svg> */}
    </div>
  );
};

export default ChequeSpinner;
